import moment from 'moment';

export const commonHelper = {
  convertUtcToLocalDateForSar: (date, format) => {
    let utcDate = date + " +00";
    return moment(utcDate).local(true).format(format);
  },

  convertUtcToLocalDate: (date, format) => {
    let utcDate = moment(new Date(date));
    return moment(utcDate).local().format(format);
  },

  /**
   * Convert local datetime to UTC for API submission
   * Takes a date in local timezone and converts to UTC format
   * @param {string|Date|moment} date - Local datetime (from DatePicker or user input)
   * @param {string} format - Moment format string (default: 'YYYY-MM-DD HH:mm:ss')
   * @returns {string} UTC datetime formatted string
   */
  convertLocalToUtc: (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!date) return '';
    // Parse as local time and convert to UTC
    return moment(date).utc().format(format);
  },

  generateRandomString: (length = 10) => {
    var characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    var randomString = '';

    for (var i = 0; i < length; i++) {
      randomString = randomString + characters[Math.floor(Math.random() * charactersLength)];
    }
    return randomString;
  },

  generateColorInUse: (daysInUse) => {
    if(daysInUse >= 0 && daysInUse < 10){
      return '#FFE599'
    }else if(daysInUse >= 10 && daysInUse < 20){
      return '#F9CA9C'
    }else if(daysInUse >= 20 && daysInUse < 30){
      return '#F6B26A'
    }else if(daysInUse >= 30 && daysInUse < 40){
      return '#EA9999'
    }else if(daysInUse >= 40 && daysInUse < 50){
      return '#E06666'
    }else{
      return '#CC0000'
    }
  },
  generateRestColor: (restDays) => {
    if(restDays >= 0 && restDays < 10){
      return '#FFF2CC'
    }else if(restDays >= 10 && restDays < 20){
      return '#D9EAD3'
    }else if(restDays >= 20 && restDays < 30){
      return '#B6D7A7'
    }else if(restDays >= 30 && restDays < 40){
      return '#92C47C'
    }else if(restDays >= 40 && restDays < 50){
      return '#69A84F'
    }else{
      return '#33A854'
    }
  },

  dataURLtoFile : (dataUrl, filename) => {
    const extension = dataUrl.split(';')[0].split('/')[1];
    var arr = dataUrl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
  
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
  
    return new File([u8arr], `${filename}.${extension}`, { type: mime });
  },

  convertBase64 : (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    })
  },

  kmToFeet: (km) => {
    return km * 3280.84;
  },

  msToKnots: (msSpeed) => {
    return (msSpeed * 1.94384449).toFixed(2);
  },

  msToKmh: (msSpeed, decimals = 1) => {
    return parseFloat((msSpeed * 3.6).toFixed(decimals));
  },

  /**
   * Display datetime in local timezone
   * Converts UTC datetime to device's local timezone and formats it
   * @param {string|Date} date - UTC datetime from backend
   * @param {string} format - Moment format string (default: 'DD/MM/YYYY HH:mm')
   * @returns {string} Formatted datetime in local timezone
   */
  displayDateTimeLocal: (date, format = 'DD/MM/YYYY HH:mm') => {
    if (!date) return '';
    return moment.utc(date).local().format(format);
  },

  /**
   * Display date (without time) in local timezone
   * @param {string|Date} date - UTC date from backend
   * @param {string} format - Moment format string (default: 'DD/MM/YYYY')
   * @returns {string} Formatted date in local timezone
   */
  displayDateLocal: (date, format = 'DD/MM/YYYY') => {
    if (!date) return '';
    return moment.utc(date).local().format(format);
  },

  /**
   * Safely parse a JSON value from localStorage.
   * Returns null if the key is missing, "undefined", or contains invalid JSON.
   * @param {string} key - localStorage key
   * @returns {any|null}
   */
  safeGetLocalStorage: (key) => {
    try {
      const raw = localStorage.getItem(key);
      return raw && raw !== "undefined" ? JSON.parse(raw) : null;
    } catch (e) {
      console.warn(`Failed to parse localStorage key "${key}":`, e);
      return null;
    }
  },

  /**
   * Shorthand — reads and parses the "active_property" localStorage key safely.
   * @returns {object|null}
   */
  getActiveProperty: () => {
    return commonHelper.safeGetLocalStorage('active_property');
  }
}